import { useEffect, useState } from "react";
import { X, ArrowUpRight } from "lucide-react";
import { publicApi } from "../admin/api";

const DISMISS_KEY = "ih_ann_dismissed_v";

/**
 * Announcement strip shown above the navbar when enabled in admin settings.
 * Dismissible: remembers the dismissal keyed on the announcement content so
 * a new announcement shows again even after dismissal.
 */
export default function AnnouncementBar() {
  const [ann, setAnn] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    publicApi
      .get("/settings")
      .then((r) => {
        if (!r.data?.announcement_enabled || !r.data?.announcement_text) {
          setAnn(null);
          return;
        }
        setAnn(r.data);
        const key = DISMISS_KEY + btoa(unescape(encodeURIComponent(r.data.announcement_text))).slice(0, 16);
        if (sessionStorage.getItem(key)) setDismissed(true);
      })
      .catch(() => {});
  }, []);

  if (!ann || dismissed) return null;

  const dismiss = () => {
    const key = DISMISS_KEY + btoa(unescape(encodeURIComponent(ann.announcement_text))).slice(0, 16);
    sessionStorage.setItem(key, "1");
    setDismissed(true);
  };

  const bg = ann.announcement_color || "#C48F56";
  const Wrapper = ann.announcement_url ? "a" : "div";
  const wrapperProps = ann.announcement_url
    ? { href: ann.announcement_url, target: "_blank", rel: "noreferrer" }
    : {};

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-[60] text-black"
      style={{ backgroundColor: bg }}
    >
      <Wrapper
        {...wrapperProps}
        className="block"
      >
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-2.5 flex items-center justify-center gap-3 text-sm font-medium">
          <span
            data-testid="announcement-text"
            className="truncate"
          >
            {ann.announcement_text}
          </span>
          {ann.announcement_url && (
            <ArrowUpRight size={14} className="shrink-0" />
          )}
        </div>
      </Wrapper>
      <button
        onClick={dismiss}
        data-testid="announcement-dismiss"
        aria-label="Chiudi avviso"
        className="absolute right-4 top-1/2 -translate-y-1/2 h-6 w-6 rounded-full grid place-items-center hover:bg-black/10"
      >
        <X size={14} />
      </button>
    </div>
  );
}
